import { cn } from 'common/utils'

const PageSection = ({ className, children }) => {
  return <div className={cn('bg-gray-50 mt-2 md:my-4 p-4 md:rounded-xl border', className)}>{children}</div>
}

export default PageSection
